'use client'

import { openChatbot } from 'chatbot/utils/openChatbot/openChatbot'
import { ButtonSecondary } from 'fukku/Button/Secondary'
import {
	sendOnClickContactButton,
	sendOnClickContactLabel,
} from 'help/utils/analytics/analyticsEvents'
import { ClientLabel } from 'labels/client'
import { useLabels } from 'labels/hooks/useLabels/useLabels'

import style from './ChatContact.module.scss'
import text from 'fukku/styles/texts.module.scss'

interface ChatContactProps {
	chatAnalyticLabel: string
	description: string
	categoryName?: string
	questionName?: string
	showContact?: () => void
}

export function ChatContact({
	categoryName,
	chatAnalyticLabel,
	questionName,
	description,
	showContact,
}: ChatContactProps) {
	const { t } = useLabels()

	const handleChatButtonClick = () => {
		sendOnClickContactLabel({
			label: chatAnalyticLabel,
			categoryName,
			questionName,
		})
		openChatbot()
	}

	const handleSeeContactOptionsClick = () => {
		sendOnClickContactButton({ categoryName, questionName })
		if (showContact) {
			showContact()
		}
	}
	return (
		<>
			<div className={`${text.bodyM} ${style.description}`}>
				<ClientLabel>{description}</ClientLabel>
			</div>
			<ButtonSecondary
				aria-label={t('accessibility.help.openChatbot.button')}
				data-testid='help.footer.contactOptions.chat.button'
				className={style.button}
				onClick={handleChatButtonClick}
			>
				{t('help.footer.moreHelp.contact.button')}
			</ButtonSecondary>
			<div className={`${text.bodyM} ${style.moreOptions}`}>
				<ClientLabel
					buttonProps={{
						onClick: () => handleSeeContactOptionsClick(),
						'data-testid': 'help.footer.moreHelp.contactOptions.link',
					}}
				>
					{t('help.footer.contactOption.text')}
				</ClientLabel>
			</div>
		</>
	)
}
